import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../../utils/AuthContext/authcontext";

const ProtectedRoute =  ({ children }) => {
  const { user, userData, claims } = useAuth();

  if (userData == null) {
    return <Navigate to="/home" />;
  }
  
  if (!user || claims?.role !== 'admin') {
    return <Navigate to="/home" />;
  }

  return children;
};

export default ProtectedRoute;
